// Explicit allowlist verified against the production catalog on 2026-10-26.
// Add new UI data sources here; never enumerate auth/session tables for export.
export interface ExportSource {
  schema: 'public' | 'hero'; table: string; label: string; group: string;
  kind: 'table' | 'view'; order: readonly string[]; columns: readonly string[];
}

export const EXPORT_SOURCES: readonly ExportSource[] = [
  {
    "schema": "hero",
    "table": "w_accecat",
    "label": "장신구 분류",
    "group": "장비 기준정보",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "key",
      "slot",
      "order",
      "name",
      "name_en",
      "slot_en"
    ]
  },
  {
    "schema": "hero",
    "table": "w_armorcat2",
    "label": "방어구 분류",
    "group": "장비 기준정보",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "key",
      "name",
      "description",
      "comment",
      "mat",
      "slot",
      "order",
      "name_en",
      "description_en",
      "comment_en",
      "slot_en",
      "mat_en"
    ]
  },
  {
    "schema": "hero",
    "table": "w_stat",
    "label": "장비 스탯",
    "group": "장비 기준정보",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "key",
      "is_b",
      "info_cat",
      "info_order",
      "value_cat",
      "lower",
      "upper",
      "is_add",
      "is_mult",
      "weight_item_level",
      "name",
      "name_en"
    ]
  },
  {
    "schema": "hero",
    "table": "w_weaponcat2",
    "label": "무기 분류",
    "group": "장비 기준정보",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "key",
      "name",
      "RepStat1",
      "comment",
      "slot",
      "order",
      "profession",
      "is_magic",
      "is_heal",
      "is_ranged",
      "physic_attack_coef",
      "physic_crit_dmg_coef",
      "stat",
      "value",
      "is_level_dependent",
      "RepStat2",
      "name_en",
      "slot_en",
      "comment_en"
    ]
  },
  {
    "schema": "public",
    "table": "boss_animations_renewed",
    "label": "모션·연출",
    "group": "스킬·효과",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "boss_code",
      "action_type",
      "motion_type",
      "montage_name",
      "icon_url",
      "sort_order",
      "created_at",
      "updated_at",
      "has_sound_effect",
      "has_vfx",
      "has_animation"
    ]
  },
  {
    "schema": "public",
    "table": "boss_effect_renewed",
    "label": "효과",
    "group": "스킬·효과",
    "kind": "table",
    "order": [
      "id",
      "key"
    ],
    "columns": [
      "key",
      "name",
      "description",
      "order",
      "boss_code",
      "cat",
      "affect",
      "dispel",
      "is_shared",
      "is_mutual",
      "tick_period_s",
      "max_count",
      "is_from_affected",
      "in_stat",
      "out_stat",
      "special_params",
      "operator",
      "id",
      "game_version",
      "duration_type"
    ]
  },
  {
    "schema": "public",
    "table": "boss_info_renewed",
    "label": "보스 정보 뷰",
    "group": "레이드·몬스터",
    "kind": "view",
    "order": [
      "boss_code"
    ],
    "columns": [
      "id",
      "boss_code",
      "boss_name",
      "description",
      "max_hp",
      "phase_count",
      "created_at",
      "updated_at"
    ]
  },
  {
    "schema": "public",
    "table": "boss_room",
    "label": "룸",
    "group": "레이드·몬스터",
    "kind": "table",
    "order": [
      "room_code"
    ],
    "columns": [
      "room_code",
      "room_name",
      "description",
      "created_at"
    ]
  },
  {
    "schema": "public",
    "table": "boss_rooms",
    "label": "룸 배치",
    "group": "레이드·몬스터",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "room_code",
      "phase",
      "map_code",
      "metadata",
      "created_at",
      "updated_at"
    ]
  },
  {
    "schema": "public",
    "table": "boss_skill_effect_relation_renewed",
    "label": "스킬–효과 연결",
    "group": "스킬·효과",
    "kind": "table",
    "order": [
      "skill",
      "effect",
      "order"
    ],
    "columns": [
      "skill",
      "effect",
      "order",
      "power",
      "duration_s",
      "add_count",
      "property_category",
      "property_element",
      "priority"
    ]
  },
  {
    "schema": "public",
    "table": "boss_skill_renewed",
    "label": "스킬",
    "group": "스킬·효과",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "key",
      "name",
      "description",
      "boss_code",
      "order",
      "casting_time_s",
      "self_cooldown_s",
      "range",
      "warning_ground",
      "warning_cast_bar",
      "target",
      "area",
      "area_radius",
      "is_interruptable",
      "custom_area_description",
      "initial_cooldown_s",
      "channeling_time_s",
      "id"
    ]
  },
  {
    "schema": "public",
    "table": "boss_trigger_condition_group_v3",
    "label": "조건 그룹",
    "group": "트리거",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "trigger_id",
      "group_name",
      "logic_operator",
      "created_at",
      "updated_at"
    ]
  },
  {
    "schema": "public",
    "table": "boss_trigger_condition_v3",
    "label": "조건",
    "group": "트리거",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "group_id",
      "nested_group_id",
      "participant_role_code",
      "value_type_code",
      "operator_code",
      "compare_value",
      "custom_property_name",
      "effect_code",
      "sort_order",
      "created_at",
      "updated_at"
    ]
  },
  {
    "schema": "public",
    "table": "drop_item",
    "label": "드롭 아이템",
    "group": "드롭템",
    "kind": "table",
    "order": [
      "item_key",
      "item_level"
    ],
    "columns": [
      "item_key",
      "item_name",
      "drop_from_entity",
      "equipment_type",
      "equipment_category_key",
      "item_set_key",
      "stat_str",
      "stat_dex",
      "stat_vit",
      "stat_int",
      "stat_foc",
      "stat_wiz",
      "stat_physic_attack_prof",
      "stat_magic_spell_prof",
      "stat_physic_block_prof",
      "stat_physic_dodge_prof",
      "stat_magic_resist_prof",
      "stat_physic_armor",
      "stat_magic_armor",
      "stat_fire_armor",
      "stat_frost_armor",
      "stat_poison_armor",
      "stat_shadow_armor",
      "stat_electr_armor",
      "memo",
      "created_at",
      "updated_at",
      "stat_extra_armor",
      "item_level",
      "bind_type",
      "theme_tag",
      "source_type",
      "drop_rate",
      "is_bind_on_pickup",
      "min_ilvl",
      "max_ilvl",
      "min_qty",
      "max_qty"
    ]
  },
  {
    "schema": "public",
    "table": "drop_item_set",
    "label": "아이템 세트",
    "group": "드롭템",
    "kind": "table",
    "order": [
      "set_key"
    ],
    "columns": [
      "set_key",
      "set_name",
      "set2_stat_key",
      "set2_value",
      "set3_stat_key",
      "set3_value",
      "set4_stat_key",
      "set4_value",
      "set5_stat_key",
      "set5_value",
      "created_at",
      "updated_at"
    ]
  },
  {
    "schema": "public",
    "table": "effect_images",
    "label": "효과 이미지 정보",
    "group": "스킬·효과",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "effect_key",
      "image_url",
      "image_uploaded_at",
      "created_at",
      "updated_at"
    ]
  },
  {
    "schema": "public",
    "table": "inf_action_type_renewed",
    "label": "inf_action_type_renewed",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "action_code"
    ],
    "columns": [
      "action_code",
      "action_name",
      "description",
      "sort_order",
      "created_at",
      "updated_at",
      "required_params",
      "optional_params"
    ]
  },
  {
    "schema": "public",
    "table": "inf_calculation_method_renewed",
    "label": "inf_calculation_method_renewed",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "method_id"
    ],
    "columns": [
      "method_id",
      "method_code",
      "method_name",
      "description",
      "sort_order",
      "created_at",
      "updated_at",
      "formula_example"
    ]
  },
  {
    "schema": "public",
    "table": "inf_condition_operator",
    "label": "inf_condition_operator",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "operator_code"
    ],
    "columns": [
      "operator_code",
      "symbol",
      "description",
      "sort_order",
      "operator_name"
    ]
  },
  {
    "schema": "public",
    "table": "inf_condition_value_type_renewed",
    "label": "inf_condition_value_type_renewed",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "value_type_code"
    ],
    "columns": [
      "value_type_code",
      "value_type_name",
      "category",
      "unit_type",
      "description",
      "sort_order",
      "created_at",
      "updated_at"
    ]
  },
  {
    "schema": "public",
    "table": "inf_effect_affect_renewed",
    "label": "inf_effect_affect_renewed",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "affect_id"
    ],
    "columns": [
      "affect_id",
      "affect_code",
      "affect_name",
      "description",
      "is_self_affected",
      "is_hero_affected",
      "is_enemy_affected",
      "is_coord_affected",
      "sort_order"
    ]
  },
  {
    "schema": "public",
    "table": "inf_effect_dispel_renewed",
    "label": "inf_effect_dispel_renewed",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "dispel_id"
    ],
    "columns": [
      "dispel_id",
      "dispel_code",
      "dispel_name",
      "description",
      "sort_order"
    ]
  },
  {
    "schema": "public",
    "table": "inf_effect_type_renewed",
    "label": "inf_effect_type_renewed",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "effect_id"
    ],
    "columns": [
      "effect_id",
      "effect_code",
      "effect_name",
      "description",
      "value",
      "sort_order",
      "category"
    ]
  },
  {
    "schema": "public",
    "table": "inf_entity_type",
    "label": "inf_entity_type",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "entity_type_id"
    ],
    "columns": [
      "entity_type_id",
      "entity_code",
      "entity_name",
      "description",
      "is_visible",
      "is_targetable",
      "has_ai",
      "sort_order"
    ]
  },
  {
    "schema": "public",
    "table": "inf_event_type_renewed",
    "label": "inf_event_type_renewed",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "event_code"
    ],
    "columns": [
      "event_code",
      "event_name",
      "description",
      "sort_order",
      "created_at",
      "updated_at",
      "is_deprecated"
    ]
  },
  {
    "schema": "public",
    "table": "inf_participant_role_renewed",
    "label": "inf_participant_role_renewed",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "role_code"
    ],
    "columns": [
      "role_code",
      "role_name",
      "description",
      "sort_order",
      "created_at",
      "updated_at",
      "is_dynamic"
    ]
  },
  {
    "schema": "public",
    "table": "inf_property_category",
    "label": "inf_property_category",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "category_code"
    ],
    "columns": [
      "category_code",
      "category_name",
      "description",
      "display_order"
    ]
  },
  {
    "schema": "public",
    "table": "inf_property_element",
    "label": "inf_property_element",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "element_code"
    ],
    "columns": [
      "element_code",
      "element_name",
      "element_color",
      "description",
      "display_order"
    ]
  },
  {
    "schema": "public",
    "table": "inf_property_operation",
    "label": "inf_property_operation",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "operation_code"
    ],
    "columns": [
      "operation_code",
      "operation_name",
      "operation_symbol",
      "description"
    ]
  },
  {
    "schema": "public",
    "table": "inf_skill_area_type",
    "label": "inf_skill_area_type",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "area_code"
    ],
    "columns": [
      "area_code",
      "area_name",
      "description",
      "sort_order",
      "created_at",
      "updated_at",
      "requires_text_input"
    ]
  },
  {
    "schema": "public",
    "table": "inf_stat_renewed",
    "label": "inf_stat_renewed",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "stat_id"
    ],
    "columns": [
      "stat_id",
      "stat_code",
      "stat_name",
      "stat_category",
      "description",
      "is_percentage",
      "sort_order"
    ]
  },
  {
    "schema": "public",
    "table": "inf_target_type_renewed",
    "label": "inf_target_type_renewed",
    "group": "기준정보",
    "kind": "table",
    "order": [
      "target_code"
    ],
    "columns": [
      "target_code",
      "target_name",
      "description",
      "sort_order",
      "created_at",
      "updated_at",
      "target_id"
    ]
  },
  {
    "schema": "public",
    "table": "raid",
    "label": "레이드",
    "group": "레이드·몬스터",
    "kind": "table",
    "order": [
      "raid_code"
    ],
    "columns": [
      "raid_code",
      "raid_name",
      "raid_room_code",
      "dungeon_x",
      "dungeon_y",
      "min_entry_level",
      "created_at",
      "updated_at"
    ]
  },
  {
    "schema": "public",
    "table": "raid_entity_renewed",
    "label": "보스·쫄몹·오브젝트",
    "group": "레이드·몬스터",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "entity_code",
      "entity_name",
      "entity_type",
      "parent_code",
      "description",
      "max_hp",
      "phase_count",
      "size_tiles",
      "spawn_limit",
      "lifetime_s",
      "created_at",
      "updated_at",
      "game_version",
      "spawn_raid_code",
      "spawn_order",
      "spawn_room_code",
      "stat_str",
      "stat_dex",
      "stat_vit",
      "stat_int",
      "stat_foc",
      "stat_wiz",
      "stat_physic_base_power",
      "stat_magic_attack_power",
      "stat_physic_attack_prof",
      "stat_magic_spell_prof",
      "stat_physic_block_prof",
      "stat_physic_dodge_prof",
      "stat_magic_resist_prof",
      "stat_physic_armor",
      "stat_magic_armor",
      "stat_fire_armor",
      "stat_frost_armor",
      "stat_poison_armor",
      "stat_shadow_armor",
      "stat_electr_armor",
      "balance_status",
      "balance_note",
      "combat_rules"
    ]
  },
  {
    "schema": "public",
    "table": "raid_room_assignment",
    "label": "레이드–룸·대표 보스",
    "group": "레이드·몬스터",
    "kind": "table",
    "order": [
      "raid_code",
      "room_code"
    ],
    "columns": [
      "raid_code",
      "room_code",
      "room_order",
      "representative_codes"
    ]
  },
  {
    "schema": "public",
    "table": "skill_images",
    "label": "스킬 이미지 정보",
    "group": "스킬·효과",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "skill_key",
      "image_url",
      "image_uploaded_at",
      "created_at",
      "updated_at"
    ]
  },
  {
    "schema": "public",
    "table": "trigger_action_v3",
    "label": "액션",
    "group": "트리거",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "trigger_id",
      "action_order",
      "action_type",
      "target_role",
      "action_params",
      "delay_seconds",
      "created_at"
    ]
  },
  {
    "schema": "public",
    "table": "trigger_definition_v3",
    "label": "V3 트리거",
    "group": "트리거",
    "kind": "table",
    "order": [
      "id"
    ],
    "columns": [
      "id",
      "trigger_code",
      "trigger_name",
      "entity_code",
      "event_type",
      "event_params",
      "event_participants",
      "is_enabled",
      "is_repeatable",
      "max_trigger_count",
      "current_trigger_count",
      "priority",
      "description",
      "created_at",
      "updated_at"
    ]
  }
];

export const sourceKey = (source: ExportSource) => source.schema + '/' + source.table;
